import {styled} from '../../styled-components';

export const TableStyle = styled.table`
    display: table;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    font-family: ${props => props.theme.typography.fontFamily};
`;
